// src/components/MembershipProductCard.js
import React, { useState } from "react";
import { useShoppingCart } from "../context/ShoppingCartContext";
import "./MembershipProductCard.css"; // updated import

const getEffectiveMetadata = (product) => ({
  ...(product.metadata || {}),
  ...(product.price?.metadata || {}),
});

const getMembershipCategory = (metadata) => {
  const serviceAccess = String(metadata.serviceAccess || "").toLowerCase();
  const productType = String(metadata.productType || "").toLowerCase();

  if (serviceAccess === "both" || productType.includes("combo")) {
    return "combo";
  }

  if (
    serviceAccess === "infrared" ||
    serviceAccess === "sauna" ||
    productType.includes("sauna")
  ) {
    return "sauna";
  }

  if (
    serviceAccess === "redlight" ||
    serviceAccess === "red-light" ||
    productType.includes("red-light") ||
    productType.includes("redlight")
  ) {
    return "red-light";
  }

  return "combo";
};

// Helper function to determine sort order for prices.
const getPriceOrder = (price) => {
  if (!price.recurring) return 100;
  const { interval, interval_count } = price.recurring;
  if (interval === "month") {
    if (interval_count === 1) return 1;
    if (interval_count === 3) return 2;
    if (interval_count === 6) return 3;
  }
  if (interval === "year") return 4;
  return 100;
};

const MembershipProductCard = ({ product, friendlyNames, typeLabel }) => {
  // Get the addItem function from the shopping cart context
  const { addItem } = useShoppingCart();
  const metadata = getEffectiveMetadata(product);

  // Sort the product prices using our custom order.
  const sortedPrices = product.prices
    ? [...product.prices].sort((a, b) => getPriceOrder(a) - getPriceOrder(b))
    : [];

  // Set the default selected price as the first option.
  const [selectedPriceId, setSelectedPriceId] = useState(
    sortedPrices.length > 0 ? sortedPrices[0].id : ""
  );

  const handleAddToCart = () => {
    const membershipCategory = getMembershipCategory(metadata);

    addItem({
      priceId: selectedPriceId,
      quantity: 1,
      // Get the selected price details.
      price:
        sortedPrices.find((price) => price.id === selectedPriceId)
          ?.unit_amount || 0,
      type: "membership",
      name: product.name,
      membershipCategory: membershipCategory,
      productType: metadata.productType || "membership",
      creditModel: metadata.creditModel || null,
      creditCategory: metadata.creditCategory || "membership",
      serviceAccess: metadata.serviceAccess || null,
      sessionCredits: metadata.sessionCredits || metadata.totalSessions || 0,
      totalSessions:
        Number(metadata.totalSessions || metadata.sessionCredits) || 0,
      isUnlimited:
        metadata.isUnlimited === true || metadata.isUnlimited === "true",
      priorityBooking:
        metadata.priorityBooking === true ||
        metadata.priorityBooking === "true",
    });
  };
  return (
    <div className="membership-product-card">
      <h3>{product.name}</h3>
      <p>{product.description}</p>
      {metadata && metadata.sku && (
        <p>SKU: {metadata.sku}</p>
      )}
      {metadata.sessionCredits &&
        metadata.sessionCredits !== "unlimited" &&
        metadata.billingCycle === "monthly" && (
          <p>{metadata.sessionCredits} shared sessions per month</p>
        )}
      {metadata.isUnlimited === "true" && <p>Unlimited monthly access</p>}
      {sortedPrices.length > 0 ? (
        <div>
          <h4>Pricing Options:</h4>
          <select
            value={selectedPriceId}
            onChange={(e) => setSelectedPriceId(e.target.value)}
            className="price-select"
          >
            {sortedPrices.map((price) => {
              let label = "";
              if (price.recurring) {
                const { interval, interval_count } = price.recurring;
                if (interval === "month") {
                  if (interval_count === 1) {
                    label = "Monthly";
                  } else if (interval_count === 3) {
                    label = "Every 3 Months";
                  } else if (interval_count === 6) {
                    label = "Every 6 Months";
                  } else {
                    label = `${interval_count} months`;
                  }
                } else if (interval === "year") {
                  label = "Yearly";
                } else {
                  label = `${interval_count} ${interval}${
                    interval_count > 1 ? "s" : ""
                  }`;
                }
              } else {
                label = "One-Time";
              }
              return (
                <option key={price.id} value={price.id}>
                  {label} - ${(price.unit_amount / 100).toFixed(2)}{" "}
                  {price.currency.toUpperCase()}
                </option>
              );
            })}
          </select>
          <button className="add-to-cart-btn" onClick={handleAddToCart}>
            Add to Cart
          </button>
        </div>
      ) : (
        <p>Price not available</p>
      )}
    </div>
  );
};

export default MembershipProductCard;
